import { Data } from './data';
import { EnregistrementInventaire } from './enregistrementinventaire';
import { plainToClass } from 'class-transformer';

export class Inventaire extends Data {

    reference: string;
    products: EnregistrementInventaire[];
    state: string;

    constructor() {

        super();
        // this.montant = 0;
    }

    /* get text(): string{

        return this.designation;
    }

    get value(): number{

        return this.id;
    } */

    get formatDateInventaire(): string {

        if (this.date_create !== null)
        return  this.formatDate(this.date_create);
        else
        return '';
    }

    get theo(): number {

        let result: number  = 0;

        const pr = plainToClass(EnregistrementInventaire, this.products);

        for ( let i = 0; i < pr.length; i++) {

            const elem = Number(pr[i].stocktheo);

            result += elem;

        }

        return result;
    }

    get reel(): number {

        let result: number  = 0;

        const pr = plainToClass(EnregistrementInventaire, this.products);

        for ( let i = 0; i < pr.length; i++) {

            const elem = Number(pr[i].stockreel);

            result += elem;

        }

        return result;
    }

    get ecart(): number {

        let result: number  = 0;

        const pr = plainToClass(EnregistrementInventaire, this.products);

        for ( let i = 0; i < pr.length; i++) {

            const elem = Number(pr[i].ecart);

            result += elem;

        }

        return result;
    }

    get ValEcart(): number {

        let result: number  = 0;

        const pr = plainToClass(EnregistrementInventaire, this.products);

        for ( let i = 0; i < pr.length; i++) {

            const elem = Number(pr[i].valorisationEcart );

            result += elem;

        }

        return result;
    }

    get pertes(): number {

        let result: number  = 0;

        const pr = plainToClass(EnregistrementInventaire, this.products);

        for ( let i = 0; i < pr.length; i++) {

            const elem = Number(pr[i].ecart);

            if (elem < 0)
            result += elem;

        }

        return result;

    }

    get surplus(): number {

        let result: number  = 0;

        const pr = plainToClass(EnregistrementInventaire, this.products);

        for ( let i = 0; i < pr.length; i++) {

            const elem = Number(pr[i].ecart);

            if (elem > 0)
            result += elem;

        }

        return result;
    }



}
